module.exports = __webpack_public_path__ + "static/media/b1.b8e62b06.jpg";